import { render, staticRenderFns } from "./drilldown-perf-pullup.vue?vue&type=template&id=3a074ffa&scoped=true"
import script from "./drilldown-perf-pullup.ts?vue&type=script&lang=ts&external"
export * from "./drilldown-perf-pullup.ts?vue&type=script&lang=ts&external"
import style0 from "./drilldown-perf-pullup.scss?vue&type=style&index=0&id=3a074ffa&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a074ffa",
  null
  
)

export default component.exports